import React, { useState, useEffect } from "react";
import "./savings.css";
import savingsCash from "../../assets/savings-cash.png";
import arrow from "../../assets/arrow2.png";
import { getCurrency } from "../../utils/Utilities";

const Savings = () => {
  const [employees, setEmployees] = useState(50);
  const [paperCards, setPaperCards] = useState(250);
  const [paperCardCost, setPaperCardCost] = useState(3);
  const [currency, setCurrency] = useState({
    currencySymbol: "₹",
    currencyName: "Rupees",
  });
  let cardPrice = currency?.currencySymbol === "₹" ? 499 : 40; // change this for pricing according to country

  const getCountry = async () => {
    const result = await getCurrency();
    setCurrency(result);
  };

  useEffect(() => {
    getCountry();
  }, []);

  let saving = paperCardCost * paperCards * employees - cardPrice * employees;

  // clamp values between min and max
  const clampValue = (val, min, max) => {
    let num = Number(val);
    if (isNaN(num)) return min;
    if (num < min) return min;
    if (num > max) return max;
    return num;
  };

  const commitEmployees = () => {
    let num = parseInt(employees, 10);

    if (isNaN(num) || num < 1) num = 1;
    if (num > 10000) num = 10000;

    setEmployees(String(num));
  };
  const handleArrowKeys = (e, value, setValue, min, max) => {
    if (e.key === "ArrowUp") {
      e.preventDefault();
      let num = parseInt(value || "0", 10) || 0;
      num = Math.min(num + 1, max);
      setValue(String(num));
    }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      let num = parseInt(value || "0", 10) || 0;
      num = Math.max(num - 1, min);
      setValue(String(num));
    }
  };

  return (
    <div id="savings" className="boxWrapper savingsboxwrapper">
      <div className="savingsinnerDiv">
        <div className="top">
          <div className="heading">
            <h1>See How Much You Save Instantly</h1>
          </div>
          <div className="para">
            <p>
              Paper cards keep draining your money year after year. Business Bay
              NFC cards are a one-time investment that saves you thousands while
              cutting waste. Use the calculator below to see how much you can
              save by going digital.
            </p>
          </div>
        </div>
        <div className="bottom">
          <div className="form">
            <div className="formLeft">
              <div className="formGroup">
                <label>How many employees need a card?</label>
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  placeholder="e.g. 50"
                  value={employees}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, "");
                    if (val === "" || parseInt(val, 10) <= 10000) {
                      setEmployees(val);
                    }
                  }}
                  onBlur={() => {
                    let num = parseInt(employees, 10);
                    if (isNaN(num) || num < 1) num = 1;
                    if (num > 10000) num = 10000;
                    setEmployees(String(num));
                  }}
                  onKeyDown={(e) =>
                    handleArrowKeys(e, employees, setEmployees, 1, 10000)
                  }
                />
              </div>
              <div className="formGroup">
                <label>
                  How many paper cards does each employee use yearly?
                </label>
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  placeholder="e.g. 250"
                  value={paperCards}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, "");
                    if (val === "" || parseInt(val, 10) <= 100000) {
                      setPaperCards(val);
                    }
                  }}
                  onBlur={() => {
                    let num = parseInt(paperCards, 10);
                    if (isNaN(num) || num < 1) num = 1;
                    if (num > 100000) num = 100000;
                    setPaperCards(String(num));
                  }}
                  onKeyDown={(e) =>
                    handleArrowKeys(e, paperCards, setPaperCards, 1, 100000)
                  }
                />
              </div>
              <div className="formGroup">
                <label>
                  What’s the average cost per paper card (
                  {currency?.currencySymbol})?
                </label>
                <p className="labelPara">
                  Includes printing, design, and delivery costs – usually
                  between {currency?.currencySymbol}1 to{" "}
                  {currency?.currencySymbol}5 per card.
                </p>
                <input
                  type="text"
                  disabled
                  className="disabledInput"
                  placeholder="0"
                  value={paperCardCost}
                />
              </div>
              <div className="formGroup formRange">
                <input
                  type="range"
                  min={currency?.currencySymbol === "₹" ? 2 : 0.4}
                  max={currency?.currencySymbol === "₹" ? 10 : 1.2}
                  step={currency?.currencySymbol === "₹" ? 1 : 0.1}
                  value={paperCardCost}
                  onChange={(e) => {
                    const minVal = currency?.currencySymbol === "₹" ? 2 : 0.4;
                    const maxVal = currency?.currencySymbol === "₹" ? 10 : 1.2;
                    setPaperCardCost(
                      clampValue(e.target.value, minVal, maxVal)
                    );
                  }}
                />

                {currency?.currencySymbol === "₹" ? (
                  <div className="rangeLabel">
                    <span className="rangeSpan1">2</span>
                    <span className="rangeSpan2">4</span>
                    <span className="rangeSpan3">6</span>
                    <span className="rangeSpan4">8</span>
                    <span className="rangeSpan5">10</span>
                  </div>
                ) : (
                  <div className="rangeLabel">
                    <span className="aedRangeSpan1">0.4</span>
                    <span className="aedRangeSpan2">0.6</span>
                    <span className="aedRangeSpan3">0.8</span>
                    <span className="aedRangeSpan4">1.0</span>
                    <span className="aedRangeSpan5">1.2</span>
                  </div>
                )}
              </div>
            </div>
            <div className="formRight">
              <div className="formRightTop">
                <h2>Your Return on Investment</h2>
                <p>
                  Switching to Business Bay digital NFC cards means you pay
                  once-no more printing or reordering. Save money every year
                  while upgrading to a smarter, sustainable networking solution.
                </p>
              </div>
              <div className="formRightBottom">
                <div className="rightCard inActiveCard">
                  <p>Annual Paper Card Costs: </p>
                  <h3>
                    {currency?.currencySymbol}
                    {paperCards * paperCardCost * employees}
                  </h3>
                </div>
                <div className="arrow">
                  <img src={arrow} alt="" />
                </div>
                <div className="rightCard activeCard">
                  <p>One-Time Business Bay NFC Cost: </p>
                  <h3>
                    {currency?.currencySymbol}
                    {cardPrice * employees}
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div className="formBtn">
            <button type="button">
              <p>
                That’s money back in your pocket every year-while you go 100%
                digital.
              </p>
              <div>
                <span className="savingsSpan">Your Total Savings: </span>
                <p>
                  {currency?.currencySymbol}
                  {saving > 0 ? saving : 0}
                </p>
                <img src={savingsCash} alt="" />
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Savings;
